import React, { FC, memo } from "react";

import { Container, ContainerAlias, ContainerUnits, ContainerValue } from "./styled";
import { ContainerProps } from "../types";

export const OneColumnContainer: FC<ContainerProps> = memo(({ elementConfig, renderElement }) => {
  const { options, style } = elementConfig || {};
  const { innerTemplateStyle, hideEmpty } = options || {};

  const value = renderElement({ id: "value" });
  const hasUnits = elementConfig?.children?.some(({ id }) => id === "units");

  if (!value && hideEmpty) return null;

  return (
    <Container style={innerTemplateStyle || style}>
      <ContainerAlias hasBottomMargin>
        {renderElement({ id: "alias" })}
        {renderElement({ id: "tooltip" })}
      </ContainerAlias>
      <ContainerValue>
        {value}
        {hasUnits && <ContainerUnits>{renderElement({ id: "units" })}</ContainerUnits>}
      </ContainerValue>
    </Container>
  );
});
